const API_ENDPOINTS = Object.freeze({
  SEND_OTP: "https://api.saniiro.com/api/v1/Common/Messaging/otp",
  VERIFY_OTP_AND_PURCHASE: "https://api.saniiro.com/api/v1/pricing/purchase",
  GET_COUNTRIES: "https://api.saniiro.com/api/v1/country",
  GET_STATES: "https://api.saniiro.com/api/v1/state",
  // Add more endpoints as needed
});

export default API_ENDPOINTS;
